/** Recharts stacked column: paint total (`sum(payload keys)`) at top of stack. */
export function stackedSeriesTotalTopLabel(keys: readonly string[], formatSum: (n: number) => string | number) {
  return (props: {
    x?: number;
    y?: number;
    width?: number;
    payload?: Record<string, unknown>;
  }) => {
    const x = props.x ?? 0;
    const y = props.y ?? 0;
    const width = props.width ?? 0;
    const payload = props.payload;
    if (!payload) return null;
    const sum = keys.reduce((acc, key) => acc + Number(payload[key] ?? 0), 0);
    if (!Number.isFinite(sum) || sum === 0) return null;
    const text = formatSum(sum);
    return (
      <text x={x + width / 2} y={y - 5} fill="hsl(var(--foreground))" fontSize={10} fontWeight={600} textAnchor="middle">
        {text}
      </text>
    );
  };
}

export const barTopNumericLabelProps = {
  position: 'top' as const,
  style: {
    fill: 'hsl(var(--foreground))',
    fontSize: 11,
    fontWeight: 600 as const,
  },
};
